import React, { useState, useEffect, useRef } from "react";
import "./index.css";
import { useLocation } from "react-router-dom";

// Components Imports
import SingleSelectDropDownComponent from "../../_utils/CommonDropdown/SingleSelectDropdown";
import CommonCalendar from "../../_utils/CommonCalendar";

const MisCreateSelectField = ({
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  setShowDatePicker,
  setIsDateConfirmed,
  setSelectedOption,
  selectedOption,
  setIsDropdownOpen,
  isDropdownOpen,
  setstartDateConfirm,
  setendDateConfirm,
}) => {
  const location = useLocation();

  const fieldDropdownRef = useRef(null);
  const datePickerRef = useRef(null);
  const dropdownRefs = useRef(null);
  const [dropdowns, setDropdowns] = useState({});

  const Mis_CatergoriesAccData = [
    "Beneficiary transaction",
    "Internal transaction",
    "User",
    "Bank statement",
    "Private transaction",
  ];

  const handleDateChange2 = (dates) => {
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);

    setIsDateConfirmed(true);
    setendDateConfirm(end ? new Date(end) : null);
    setstartDateConfirm(start ? new Date(start) : null);

    setShowDatePicker(false);
  };

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        fieldDropdownRef.current &&
        !fieldDropdownRef.current.contains(event.target) &&
        datePickerRef.current &&
        !datePickerRef.current.contains(event.target)
      ) {
        setIsDropdownOpen(false);
        setShowDatePicker(false);
      } else if (
        fieldDropdownRef.current &&
        !fieldDropdownRef.current.contains(event.target)
      ) {
        setIsDropdownOpen(false);
      } else if (
        datePickerRef.current &&
        !datePickerRef.current.contains(event.target)
      ) {
        setShowDatePicker(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [setIsDropdownOpen, setShowDatePicker]);

  useEffect(() => {
    const handleClickOutside2 = (event) => {
      if (
        dropdownRefs.current &&
        !dropdownRefs.current.contains(event.target)
      ) {
        let obj = {
          ...dropdowns,
          isOpen: false,
        };
        setDropdowns(obj);
      }
    };

    document.addEventListener("mousedown", handleClickOutside2);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside2);
    };
  }, []);

  useEffect(() => {
    if (selectedOption) return;
    const path = location.pathname;

    switch (true) {
      case path.includes("beneficiary_transaction_dashboard"):
        setSelectedOption("Beneficiary transaction");
        break;

      case path.includes("internal_transaction_dashboard"):
        setSelectedOption("Internal transaction");
        break;

      case path.includes("owner_account_dashboard"):
        setSelectedOption("Bank statement");
        break;

      case path.includes("private_transaction_dashboard"):
        setSelectedOption("Private transaction");
        break;

      default:
        setSelectedOption("");
        break;
    }
  }, [location.pathname]);

  return (
    <>
      <div className={`Mis_report_Main_div `}>
        <div
          style={{
            maxWidth: "var(--max-content-width)",
          }}
          className="w-width-full flex flex-col Qsmd:flex-row justify-center  gap-gap-md"
        >
          <div className="Mis_report_SelectAcc_div_owner">
            <div className="flex flex-col gap-y-gap-md relative h-fit">
              <div className="w-width-full h-fit flex flex-col gap-gap-md">
                <div className="flex flex-col gap-gap-xs">
                  <p className=" font-semibold text-text-primary text-font-md font-sans">
                    Field
                  </p>
                  <span className="font-normal text-text-secondary text-font-xs font-sans">
                    Select the field for which you want to generate the MIS
                    report.
                  </span>
                </div>

                <div
                  ref={fieldDropdownRef}
                  className={`${isDropdownOpen ? "open" : ""}`}
                  onClick={() => {
                    setIsDropdownOpen(!isDropdownOpen);
                    if (!isDropdownOpen) {
                      setShowDatePicker(false);
                    }
                  }}
                >
                  <SingleSelectDropDownComponent
                    options={Mis_CatergoriesAccData}
                    selected={selectedOption}
                    setSelected={setSelectedOption}
                    isOpen={false}
                    showSearch={false}
                    placeholder="Select field"
                    searchPlaceholder="Search"
                    disabled={false}
                    type="big"
                  />
                </div>
              </div>
            </div>
          </div>

          <div
            style={{
              opacity: "var(--base-opacity)",
              height: "fit-content",
            }}
            className="w-width-full Qsmd:w-width-md  relative p-padding-md rounded-border-radius-md bg-primary-card "
          >
            <div className="flex flex-col  relative">
              <div className="w-width-full ">
                <p className="font-semibold text-font-md text-text-secondary">
                  Date Range
                </p>

                <div className="pt-padding-md">
                  <CommonCalendar
                    startDate={startDate}
                    endDate={endDate}
                    handleDateChange={handleDateChange2}
                    type="big"
                    selectionType="range"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MisCreateSelectField;
